/**
 * Рукописная обёртка над ручками, которые УЖЕ есть в генерации Kubb
 * (3 из 3 вызовов). Кандидат на удаление: типы здесь живут отдельно
 * от контракта и молча расходятся с ним при изменении на бэкенде.
 * Новый код берёт хуки из `@/shared/api/generated-kubb/hooks` (KAN-1000).
 */
import { api } from "@/shared/lib/api";

export interface BugReport {
  title: string;
  description: string;
  page: string;
  stepsToReproduce: string;
  expectedResult: string;
  actualResult: string;
  priority: "low" | "medium" | "high" | "critical";
  browserInfo: string;
  screenshotUrl?: string;
}

export interface TesterRoleSwitch {
  role: string;
  teamId?: string;
  organizationId?: string;
}

export interface TesterStatus {
  isTester: boolean;
  userId?: string;
  username?: string;
  displayName?: string;
  roles?: string[];
  teamMemberships?: Array<{
    teamId: string;
    teamName: string;
    role: string;
  }>;
  organizationMemberships?: Array<{
    organizationId: string;
    organizationName: string;
    roleId: number;
  }>;
}

export const testerApi = {
  async getStatus(): Promise<TesterStatus> {
    const response = await api.get<TesterStatus>("/tester/status");
    return response.data;
  },

  async switchRole(
    roleSwitch: TesterRoleSwitch,
  ): Promise<{ success: boolean; message: string }> {
    const response = await api.post<{ success: boolean; message: string }>(
      "/tester/switch-role",
      roleSwitch,
    );
    return response.data;
  },

  async reportBug(
    bugReport: BugReport,
  ): Promise<{ success: boolean; message: string }> {
    const response = await api.post<{ success: boolean; message: string }>(
      "/tester/bug-report",
      bugReport,
    );
    return response.data;
  },
};
